<div *ngIf="!configs['isGrid']">
  <form [formGroup]="formGroup">
    <p-multiSelect [id]="configs['id']" [options]="list" [formControlName]="configs['id']"
      [panelStyle]="{minWidth:'12em'}" (onChange)="onChange($event)" [virtualScroll]="configs['enableVirtualScroll']"
      displaySelectedLabel="false" [itemSize]="configs['itemSize']" selectedItemsLabel="label"
      [optionLabel]="configs['optionLabel']">
      <ng-template let-value pTemplate="selectedItems">
        <div *ngFor="let val of value" class="ui-multiselected-item-token ui-corner-all">
          <!-- <img src="assets/showcase/images/demo/car/{{val}}.png" style="width:20px;vertical-align:middle;margin-right:.5em" /> -->
          <span>{{val[configs['optionLabel']]}}</span>
        </div>
        <span *ngIf="!value || value.length === 0" class="ui-multiselected-empty-token ui-corner-all">Choose</span>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div>{{item.label}}</div>
      </ng-template>
    </p-multiSelect>
  </form>
</div>

<div *ngIf="configs['isGrid']" class="grid-multiselect">
  <p-multiSelect [id]="configs['id']" [options]="list" [(ngModel)]="selectedItem" [panelStyle]="{minWidth:'12em'}"
    (onChange)="onChange($event)" [virtualScroll]="configs['enableVirtualScroll']" displaySelectedLabel="false"
    [itemSize]="configs['itemSize']" selectedItemsLabel="label" [optionLabel]="configs['optionLabel']">
    <ng-template let-value pTemplate="selectedItems">
      <div *ngFor="let val of value" class="ui-multiselected-item-token ui-corner-all">
        <!-- <img src="assets/showcase/images/demo/car/{{val}}.png" style="width:20px;vertical-align:middle;margin-right:.5em" /> -->
        <span>{{val[configs['optionLabel']]}}</span>
      </div>
      <span *ngIf="!value || value.length === 0" class="ui-multiselected-empty-token ui-corner-all">Choose</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div>{{item.label ? item.label : item.value}}</div>
    </ng-template>
  </p-multiSelect>
</div>